export const AUTO_FETCH_ITEM_INDEX = 0; // only preload for group 1st and 2nd
export const MAX_PAGE_PER_PDF = 8;

export const WISTIA_MEDIA_ID = {
  talentPool: "c3qgt2wip7",
  introFull: "f6qc6w6qcl",
  jobManagement: "f3t95oghjd",
};
